import { HttpError } from "@nestia/fetcher";

/**
 * Must match the backend `EMAIL_NOT_VERIFIED_CODE`
 * (`nest/src/auth/email-verification.constants.ts`).
 */
export const EMAIL_NOT_VERIFIED_CODE = "EMAIL_NOT_VERIFIED";

export const WAITING_ROOM_PATH = "/email-verification-waiting-room";

/**
 * True when an error is the backend's `403 EMAIL_NOT_VERIFIED` verification
 * gate — an authenticated but unverified user tried a gated operation.
 */
export const isEmailNotVerifiedError = (error: unknown): boolean => {
  if (!(error instanceof HttpError) || error.status !== 403) return false;

  const body = error.toJSON<{ code?: string }>().message;
  return body?.code === EMAIL_NOT_VERIFIED_CODE;
};
